// Shared constants & formatters for the AdminCommercial dashboard.
export const PERIODS = [
  { v: "today", l: "Hoy" },
  { v: "yesterday", l: "Ayer" },
  { v: "week", l: "Semana" },
  { v: "month", l: "Mes" },
  { v: "year", l: "Año" },
];

export const SOURCES = [
  { v: "all", l: "Todo", desc: "Portal + Presencial" },
  { v: "portal", l: "Portal", desc: "Solo marketplace" },
  { v: "arcos", l: "Presencial", desc: "Solo vendedores" },
];

export const SYNC_OPTIONS = [
  { v: 2, l: "Últimos 2 días" },
  { v: 7, l: "Últimos 7 días" },
  { v: 15, l: "Últimos 15 días" },
  { v: 30, l: "Último mes (30 d)" },
  { v: 60, l: "Últimos 2 meses" },
  { v: 90, l: "Últimos 3 meses" },
  { v: 180, l: "Últimos 6 meses" },
  { v: 365, l: "Último año" },
];

export const fmtShort = (n) => {
  if (n === null || n === undefined) return "—";
  if (Math.abs(n) >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  return `$${n.toFixed(0)}`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso + "T00:00:00").toLocaleDateString("es-CO", { day: "2-digit", month: "short" });
  } catch {
    return iso;
  }
};
